import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Page} from '../../../../global/util/enum/Page';
import {AddEditWorkflowComponent} from '../add-edit-workflow/add-edit-workflow.component';
import {Workflow} from '../../../model/Workflow';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import {WorkflowService} from '../../../service/workflow.service';
import {AddgroupParticipantComponent} from '../../participant/addgroup-participant/addgroup-participant.component';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {TemplateDesignWorkflowComponent} from '../design-template-workflow/template-design-workflow.component';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Workflowtype} from '../../../model/Workflowtype';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Router} from '@angular/router';
import {Partner} from '../../../model/Partner';
import {Dialog} from '../../../../global/util/Dialog';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {ParticipantService} from '../../../service/participant.service';
import {Participant} from '../../../model/Participant';
import {DesignTenorToNotifyComponent} from '../design-tenor-to-notify/design-tenor-to-notify.component';
import {Tenor} from '../../../model/Tenor';
import {TenorService} from '../../../service/tenor.service';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {OperationType} from '../../../../global/util/OperationType';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';
import {DesignEmailTemplateComponent} from '../design-email-template/design-email-template.component';
import {MailtemplateType} from '../../../../global/util/MailtemplateType';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-list-workflow',
  templateUrl: './list-workflow.component.html',
  styleUrls: ['./list-workflow.component.css']
})
export class ListWorkflowComponent implements OnInit {
  public enterprises: any[] = [];
  public enterpriseSelected: any;
  public enterpriseIdSelected = 0;
  public workflows: Workflow[] = [];
  public workflowtypes: Workflowtype[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public title = 'TITLE.WORKFLOW';
  private workflowUrl: string;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_ADMIN_NOTCER = Constant.ROLE_ADMIN_NOTCER;
  public ROLE_USER = Constant.ROLE_USER;
  public term2Search: string;
  public partnerSelected: Partner;
  public partners: Partner[] = [];
  private workflowIdEdited: number;
  pageNumber: any;
  pageNumbers: any[] = [];
  sendDocumentAlertPending = MailtemplateType.DOCUMENT_PENDING_SIGNATURE;
  sendDocumentAlertAttachment = MailtemplateType.SEND_DOCUMENT_ATTACHTMENT;

  constructor(private modalService: NgbModal,
              private workflowService: WorkflowService,
              private authenticationService: AuthService,
              private applicationService: ApplicationService,
              private router: Router,
              private participantService: ParticipantService,
              private tenorService: TenorService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.setDefaultData();
    this.loadWorkflow(Page.First);
  }

  private setDefaultData() {
    this.workflowtypes = LocalStorage.getWorkflowtypes();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
    }
  }

  public reloadWorkflows() {
    if (this.enterpriseSelected) {
      this.enterpriseIdSelected = this.enterpriseSelected.id;
    }
    this.workflows = [];
    this.loadWorkflow(Page.First);
  }

  public getWorkflowtypeDesc(workflow: Workflow): string {
    return this.workflowtypes.find(value => value.id === workflow.type).nameView;
  }

  public loadWorkflow(page: Page) {
    if (this.term2Search === undefined) {
      this.term2Search = '';
    }
    let partnerId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
    }
    switch (page) {
      case Page.First:
        this.workflowUrl = Constant.ROOT_API_V1
          .concat('/partners/')
          .concat(String(partnerId))
          .concat('/enterprises/')
          .concat(String(this.enterpriseIdSelected))
          .concat('/workflows')
          .concat('?findby=')
          .concat(this.term2Search)
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.workflowUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.workflowUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.workflowUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.workflowUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.loading = true;
    this.workflowService.get(this.workflowUrl).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.workflows = next._embedded.workflows;
        if (this.workflowIdEdited) {
          const workflowEdited = this.workflows.find(workflow1 => workflow1.id === this.workflowIdEdited);
          LocalStorage.updateEmbeddedValuesBy(workflowEdited, 'workflows', Constant.EDIT);
        }
        this.page = next.page;
        this.links = next._links;
      } else {
        this.workflows = [];
        this.page.totalElements = 0;
        this.page.number = 0;
        this.page.size = 0;
      }
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.WORKFLOW'), error);
    });
  }

  public openModalAdd() {
    this.loading = true;
    this.loading = false;
    this.title = this.translate.instant('TITLE.WORKFLOW');
    const modalRef = this.modalService.open(AddEditWorkflowComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.workflow = new Workflow();
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.title);
        this.loadWorkflow(this.workflows.length === 0 ? Page.First : Page.Self);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public openModalEdit(workflow: Workflow) {
    this.loading = true;
    this.loading = false;
    this.title = this.translate.instant('TITLE.WORKFLOW');
    const workflowToEdit = CloneTool.do(workflow);
    const modalRef = this.modalService.open(AddEditWorkflowComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.workflow = workflowToEdit;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadWorkflow(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public delete(workflow: Workflow) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-WORKFLOW');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-WORKFLOW');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteWorkflow(workflow);
      }
    });
  }

  private deleteWorkflow(workflow: Workflow) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.WORKFLOW');
    this.workflowService.delete(workflow.id).subscribe(workflow1 => {
      LocalStorage.updateEmbeddedValuesBy(workflow1, 'workflows', Constant.DELETE);
      this.loading = false;
      this.loadWorkflow(Page.Self);
      Dialog.show(InformType.Success, this.title);
    }, error => {
      this.loading = false;
      this.processError(this.title, error);
    });
  }

  public openModalAddParticipants(workflow: any) {
    this.title = this.translate.instant('TITLE.WORKFLOW');
    const modalRef = this.modalService.open(AddgroupParticipantComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.workflowReceived = workflow;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.workflowIdEdited = workflow.id;
        this.loadWorkflow(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public getParticipantsAndOpen(workflow: Workflow) {
    if (!workflow.dynamic) {
      if (!this.completed(workflow)) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.WORKFLOW'), this.translate.instant('MESSAGE.ADD-PARTICIPANTS-BEFORE-CUSTOMIZING-THE-TEMPLATE'));
        return;
      }
      this.loading = true;
      this.participantService.getParticipants(workflow.id).subscribe((next: any) => {
        this.loading = false;
        if (next._embedded) {
          const participants = next._embedded
            .participants.filter(workflow1 => workflow1.operationId !== OperationType.VISUALIZATION);
          this.openModalDesignTemplate(workflow, participants);
        }
      }, error => {
        this.loading = false;
        this.processError(this.translate.instant('TITLE.WORKFLOW'), error);
      });
    } else {
      this.openModalDesignTemplate(workflow, []);
    }
  }

  public openModalDesignTemplate(workflow: any, participants: Participant[]) {
    this.title = this.translate.instant('TITLE.WORKFLOW');
    const modalRef = this.modalService.open(TemplateDesignWorkflowComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.workflowReceived = workflow;
    modalRef.componentInstance.enterpriseRecived = this.enterpriseSelected;
    modalRef.componentInstance.participants = participants;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadWorkflow(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  public ready2Use(workflow: Workflow): boolean {
    return Constant.READY_TO_USE === workflow.ready2Use;
  }

  public completed(workflow: Workflow): boolean {
    return Constant.COMPLETED === workflow.completed;
  }

  public requiredSieConfig(workflow: Workflow): boolean {
    return Constant.REQUIRED_SIE_CONFIG === workflow._more.requiredSieConfig;
  }

  public sieConfigured(workflow: Workflow) {
    return this.requiredSieConfig(workflow) && Constant.SIE_CONFIGURED === workflow._more.sieConfigured;
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public search() {
    this.reloadWorkflows();
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public reloadWorkflows0() {
    this.getEnterpriseFilteredBy(this.partnerSelected.id);
  }

  public isDynamic(workflow: Workflow): boolean {
    return Constant.DYNAMICALLY === workflow.dynamic;
  }

  public isFreelySignature(workflow: Workflow): boolean {
    return workflow.freelySignature;
  }

  public duplicate(workflow: Workflow) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.WORKFLOW');
    this.workflowService.duplicateBy(workflow.id).subscribe(workflow1 => {
      this.loading = false;
      LocalStorage.updateEmbeddedValuesBy(workflow1, 'workflows', Constant.ADD);
      this.loadWorkflow(this.workflows.length === 0 ? Page.First : Page.Self);
      Dialog.show(InformType.Success, this.title);
    }, error => {
      this.loading = false;
      this.processError(this.title, error);
    });
  }

  public isActive(workflow: Workflow): boolean {
    return Constant.ACTIVE === workflow.active;
  }

  public openModalConfigTenor(workflow: Workflow) {
    this.loading = true;
    this.tenorService.getBy(workflow.id).subscribe((next: any) => {
      this.loading = false;
      this.viewModalConfigTenor(workflow, next);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.NOT_FOUND === error.status) {
        this.viewModalConfigTenor(workflow, new Tenor());
      } else {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.CONTENT'));
      }
    });
  }

  private viewModalConfigTenor(workflow: Workflow, tenor: Tenor) {
    const modalRef = this.modalService.open(DesignTenorToNotifyComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.workflow = workflow;
    modalRef.componentInstance.tenor = tenor;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadWorkflow(Page.Self);
        Dialog.show(InformType.Success, this.translate.instant('TITLE.CONTENT'));
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.CONTENT'));
      }
    });
  }

  openModalConfigEmailTemplate(workflow: Workflow, mailTemplateType: any) {
    const modalRef = this.modalService.open(DesignEmailTemplateComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.workflow = workflow;
    modalRef.componentInstance.alertType = mailTemplateType;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadWorkflow(Page.Self);
        Dialog.show(InformType.Success, this.translate.instant('TITLE.DESIGN-EMAIL-BODY-TEMPLATE'));
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.DESIGN-EMAIL-BODY-TEMPLATE'));
      }
    });
  }

  public hasEnabledNotificationByDocument(workflow: Workflow): boolean {
    return workflow.notificationByDocument ||
      (WorkflowType.UPLOAD_TO_IOFESIGN === workflow.type && (workflow.notificateAfterUpload || workflow.send2MailAfterUpload));
  }

  public hasEnabledNotcertByDocument(workflow: Workflow): boolean {
    return workflow.notificationByDocument ||
      (WorkflowType.NOTCER === workflow.type && workflow.send2Visualization);
  }

  public requiredTenorConfig(workflow: Workflow): boolean {
    return this.hasEnabledNotificationByDocument(workflow) && !workflow._more.tenorConfigured;
  }

  public requiredHasTemplate(workflow: Workflow): boolean {
    return WorkflowType.SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE === workflow.type && !workflow._more.hasTemplate;
  }

  public isNotcer(workflow: Workflow) {
    return WorkflowType.NOTCER === workflow.type;
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      this.enterprises = LocalStorage.addEnterprise(enterprises).sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
    });
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      this.enterprises = enterprises.sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param partnerId
   * @private
   */
  private getEnterpriseFilteredBy(partnerId: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (partnerId === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => partnerId === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.reloadWorkflows();
    }
  }
}
